<div class="modal-header">

  <div>
    <h4 class="modal-title">
      {{ (houseFlat?.payment?.createdAt ?? houseFlat?.movement?.createdAt) | dateToMoment: 'MMMM YYYY' }}
    </h4>
    <small>
      {{ streetBuilding?.name }} {{ houseFlat?.number }}
    </small>

  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">

  <form
    id="formPayment"
    novalidate
    [formGroup]="formPayment"
    (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <div class="row">

        @if(houseFlat?.payment?.file || houseFlat?.movement?.image) {
          <a
            [href]="(houseFlat?.payment?.file?.urlFile ?? houseFlat?.movement?.image?.urlFile)"
            target="_blank"
            class="col-12 mb-3 text-decoration-none">
            <label for="file" class="form-label text-black">Comprobante de pago</label>
            <img
              [src]="(houseFlat?.payment?.file?.urlFile ?? houseFlat?.movement?.image?.urlFile)"
              [alt]="(houseFlat?.payment?.file?.fileId ?? houseFlat?.movement?.image?.fileId)"
              class="img-thumbnail w-100">
          </a>
        } @else {
          <div class="col-12 form-group mb-4">
            <label htmlFor="imageBase64" class="form-label">
              Comprobante de pago
            </label>
            <input
              class="form-control"
              type="file"
              accept="image/*"
              id="imageBase64"
              (change)="onFileChange($event)">
          </div>
        }

        @if(isPaidWithCredit) {
          <div class="col-12 mb-3">
            <div
              id="creditLockHelp"
              class="d-flex align-items-start rounded rounded-3 bg-light py-2 px-3">
              <i
                class="material-icons text-secondary me-2"
                style="font-size: 18px;"
                aria-hidden="true">
                lock
              </i>
              <small class="text-muted">
                Este movimiento ya fue pagado en su totalidad con crédito.
                No es posible modificar la cantidad, el tipo de movimiento ni el estatus.
                Puedes actualizar las notas y el comprobante de pago.
              </small>
            </div>
          </div>
        }

        <div class="col-12 mb-3 form-group">
          <label for="charge" class="form-label">
            Cantidad
            @if(isPaidWithCredit) {
              <small class="text-muted">(No editable)</small>
            }
          </label>
          <input
            type="number"
            id="charge"
            class="form-control"
            formControlName="charge"
            step="0.01"
            min="0.01"
            placeholder="Ingrese el monto"
            [ngClass]="{
              'is-invalid': submitted && formControls['charge'].errors
            }">
          <div *ngIf="submitted && formControls['charge'].errors" class="invalid-feedback">
            <div *ngIf="formControls['charge'].errors['required']">
              Por favor, ingrese el monto
            </div>
            <div *ngIf="formControls['charge'].errors['min']">
              El monto debe ser mayor a 0
            </div>
          </div>
        </div>

        @if((houseFlat?.movement?.creditApplied ?? 0) > 0) {
          <div class="col-12 mb-3">
            <small class="text-muted">
              Crédito aplicado:
              <strong class="text-info">{{ houseFlat?.movement?.creditApplied | currency }}</strong>
            </small>
          </div>
        }

        <div class="col-12 mb-3 form-group">
          <label for="notes" class="form-label">Notas</label>
          <textarea
            id="notes"
            class="form-control"
            formControlName="notes"
            rows="5"
            placeholder="Notas (Opcional)"></textarea>
        </div>

        <div class="col-12 mb-3 form-group">
          <label for="movementType" class="form-label">
            Tipo de movimiento
            @if(isPaidWithCredit) {
              <small class="text-muted">(No editable)</small>
            }
          </label>
          <ng-select
            [items]="movementTypeOptions"
            bindLabel="label"
            bindValue="value"
            formControlName="movementType"
            placeholder="Seleccione el tipo">
          </ng-select>
        </div>

        <div class="col-12 mb-3">
          <label for="status" class="form-label">
            Estatus
            @if(isPaidWithCredit) {
              <small class="text-muted">(No editable)</small>
            }
          </label>
            <ng-select
            [items]="houseFlat?.movement && !houseFlat?.payment ? movementStatusOptions : options"
            bindLabel="label"
            bindValue="value"
            formControlName="status"
            placeholder="Seleccione el estatus del pago"
            [ngClass]="{
              'is-invalid': submitted && formControls['status'].errors
            }">
            </ng-select>
            <div *ngIf="submitted && formControls['status'].errors" class="invalid-feedback">
              <div *ngIf="formControls['status'].errors['required']">
                Por favor, seleccione el estatus del pago
              </div>
            </div>
        </div>

        <!-- Crédito disponible de la casa. Independiente del botón: se muestra
             siempre que haya crédito, aunque el cargo ya esté pagado o sea $0. -->
        @if(hasCredit) {
          <div class="col-12 mb-3 d-flex align-items-center" style="min-width: 0;">
            <i
              class="material-icons text-info me-1"
              style="font-size: 1rem;"
              aria-hidden="true">
              savings
            </i>
            <small class="text-muted text-truncate">
              Crédito disponible:
              <strong class="text-info">{{ creditBalance | currency }}</strong>
            </small>
          </div>
        }

      </div>
    </div>
  </form>
  
</div>
<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100"
      [disabled]="saving">
      Cancelar
    </button>
  </div>

  <div class="col-12">
    <button
      type="submit"
      form="formPayment"
      class="btn w-100"
      [ngClass]="updateButtonClass"
      [disabled]="saving">
      @if(savingAction === 'update') {
        <span
          class="spinner-border spinner-border-sm me-1"
          role="status">
        </span>
      }
      Actualizar
    </button>
  </div>

  @if(showPayWithCredit) {
    <div class="col-12 mt-3">

      <!-- El <span> es el host del tooltip: Bootstrap aplica pointer-events:none
           al .btn deshabilitado, así que el hover llega hasta este contenedor
           y ngbTooltip sí se muestra. -->
      <span
        class="d-block"
        placement="top"
        [ngbTooltip]="payWithCreditTooltip"
        [style.cursor]="hasEnoughCredit ? null : 'not-allowed'">
        <button
          type="button"
          class="btn btn-primary w-100"
          [disabled]="payWithCreditDisabled"
          [attr.aria-describedby]="hasEnoughCredit ? null : 'payWithCreditReason'"
          (click)="payWithCredit()">
          @if(savingAction === 'credit') {
            <span
              class="spinner-border spinner-border-sm me-1"
              role="status">
            </span>
          }
          Pagar con crédito
        </button>
      </span>

      @if(!hasEnoughCredit) {
        <span id="payWithCreditReason" class="visually-hidden">
          Crédito insuficiente: el crédito disponible no cubre el monto total de esta cuota.
        </span>
      }

    </div>
  }
</div>